// /* eslint-disable react/react-in-jsx-scope */
// import ErrorBoundary from '@components/ErrorBoundary';
// import Exception from '@components/Exception';
// import Loading from '@components/Loading';
// import Sider from '@components/Sider';
// import { routes, RouteProps } from '@lib/routes';
// import Login from '@pages/User/Login/Login';
// import { Layout, message } from 'antd';
// import React, { Suspense, useEffect, useMemo, useRef, useState } from 'react';
// import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
// import DocumentTitle from 'react-document-title';
// import classNames from 'classnames';
// import { useDispatch, useSelector } from 'react-redux';
// import store, { RootState } from 'app/store';
// import {
//   LanguageSelectType,
//   getUserCurrent,
//   updateLanguage,
//   updateToken,
//   updateUserSlideFromLC
// } from '@slice/user.slice';
// import EnDeAES from 'helpers/EnDeAES';
// import Cookies from 'js-cookie';
// import { locale } from 'devextreme/localization';
// import i18n from 'i18n/index';
// import { ThunkDispatch } from '@reduxjs/toolkit';
// import LoadingPage from '@components/common/LoadingPage';

// import AuthServiceApi from 'apis/api/Auth';
// import { useTranslation } from 'react-i18next';
// import { updateActiveMenuHeader, updateConfigStart } from '@slice/select.slice';
// import { publicUrl } from '@utils/env';
// import { CONFIG_WEBSITE } from 'global/Global';

// function App() {
//   const { t } = useTranslation();
//   const history = useNavigate();
//   const location = useLocation();
//   const refRouteList = useRef<any>([]);
//   // const account = useSelector((state: RootState) => state.user.account);
//   // const roleTag = useSelector((state: RootState) => state.user.roleTag);
//   const token = useSelector((state: RootState) => state.user.token);
//   const configStart = useSelector((state: RootState) => state.select.configStart);
//   const routesFilter = useSelector((state: RootState) => state.user.routesFilter);
//   const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

//   function RequireAuth({ children, hasSiderBar }: { children: any; hasSiderBar?: boolean }) {
//     const collapsed = useSelector((state: RootState) => state.select.isCollapsedNav);
//     if (!token) {
//       return <Navigate to="/login" state={{ from: location }} replace />;
//     } else {
//       if (hasSiderBar) {
//         return (
//           <>
//             {/* 250px là mức cố định tuân theo Siler width */}
//             <Layout
//               className={classNames(
//                 `${collapsed ? 'ml-[40px]' : 'ml-[200px]'} h-[calc(100vh-0rem)] overflow-y-auto bg-transparent`
//               )}
//             >
//               <Layout.Content>{children}</Layout.Content>
//             </Layout>
//           </>
//         );
//       }
//       return children;
//     }
//   }

//   const renderRoute = (route: RouteProps | any) => {
//     // console.log('routesFilter', routesFilter, route.key);
//     if (route.children) {
//       if (routesFilter.includes(route.key)) {
//         return null;
//       }
//       return route.children.map(renderRoute);
//     }

//     if (!route.Component || !route.url || routesFilter.includes(route.key)) {
//       return null;
//     }

//     // eslint-disable-next-line react/react-in-jsx-scope
//     refRouteList.current = Array.from(new Set([...refRouteList.current, route]));
//     return (
//       <Route
//         key={route.key}
//         path={route.url}
//         element={
//           <RequireAuth hasSiderBar={true}>
//             <route.Component />
//           </RequireAuth>
//         }
//       />
//     );
//   };

//   const _routes = routes
//     .map(r => {
//       if (r.children) {
//         if (routesFilter.includes(r.key)) {
//           return null;
//         }
//         return r.children.map(renderRoute);
//       }
//       return renderRoute(r);
//     })
//     .reduce((result: any[], route) => {
//       if (!route) {
//         return result;
//       }
//       if (Array.isArray(route)) {
//         return [...result, ...route.filter(Boolean)];
//       }

//       result.push(route);
//       return result;
//     }, []);

//   const documentTitle = React.useMemo(() => {
//     // --- 1. Kiểm tra ngôn ngữ ---
//     if (i18n.language !== 'vn' && i18n.language !== 'en') {
//       console.log('reset to vn', i18n.language);
//       locale('vi');
//       try {
//         dispatch(updateLanguage(LanguageSelectType.VIETNAM));
//         i18n.changeLanguage('vn');
//       } catch (error) {
//         console.log('error', error);
//       }
//     }

//     // --- 2. Hàm hỗ trợ ---
//     // Tìm route theo pathname (đệ quy qua children)
//     function findRouteByPath(pathname: string, routes: any[]): any | null {
//       for (const route of routes) {
//         if (route.url === pathname) return route;
//         if (route.children?.length) {
//           const child = findRouteByPath(pathname, route.children);
//           if (child) return child;
//         }
//       }
//       return null;
//     }

//     // Sinh ra mảng openTabs từ key (đa cấp)
//     function getOpenTabsByDotKey(key: string): string[] {
//       if (!key) return [];
//       const parts = key.split('.');
//       const result: string[] = [];

//       // luôn push full key trước
//       result.push(key);

//       // nếu có cha (ít nhất 1 dấu .)
//       if (parts.length > 1) {
//         const parent = parts.slice(0, parts.length - 1).join('.');
//         result.push(parent);
//       }

//       return result;
//     }

//     // --- 3. Xử lý chính ---
//     const url = location;
//     const result = findRouteByPath(url.pathname, routes);
//     if (result?.key) {
//       const dataMenuKeys = {
//         keysMenu: result?.key,
//         openTabs: getOpenTabsByDotKey(result?.key)
//       };

//       dispatch(updateActiveMenuHeader(dataMenuKeys));
//       return i18n.t(result.title);
//     } else {
//       // reset nếu không tìm thấy route
//       dispatch(updateActiveMenuHeader({ keysMenu: null, openTabs: [] }));
//       return null;
//     }
//   }, [location]);

//   // const documentTitle = React.useMemo(() => {
//   //   if (i18n.language != 'vn' && i18n.language != 'en') {
//   //     console.log('reset to vn', i18n.language);
//   //     locale('vi');
//   //     try {
//   //       dispatch(updateLanguage(LanguageSelectType.VIETNAM));
//   //       i18n.changeLanguage('vn');
//   //     } catch (error) {
//   //       console.log('error');
//   //     }
//   //   }

//   //   const url = location;
//   //   let result: any = null;
//   //   result = routes.find(item => item.url === url.pathname); // tìm ở cấp 1
//   //   // phải xử lý ở dạng menu cấp 2 cấp 3 luôn
//   //   if (!result) {
//   //     // qua cấp 2 for 1 vòng ngoài
//   //     for (let i = 0; i < routes.length; i++) {
//   //       if (result) {
//   //         break;
//   //       }
//   //       if (routes[i].children?.length) {
//   //         result = routes[i].children.find(item => item.url === url.pathname);
//   //       }
//   //     }
//   //   }

//   //   // nếu cấp 2 mà chưa có thì qua cấp 3 for child 1 và for child 2. tạm thời chưa xử lý for này
//   //   console.log('location', url.pathname, routes, result);
//   //   // routes dạng { key, title, url, children? }

//   //   function getOpenTabsByDotKey(key: string): string[] {
//   //     if (!key) return [];
//   //     const parts = key.split('.');
//   //     const result: string[] = [];

//   //     // luôn push full key trước
//   //     result.push(key);

//   //     // nếu có cha (ít nhất 1 dấu .)
//   //     if (parts.length > 1) {
//   //       const parent = parts.slice(0, parts.length - 1).join('.');
//   //       result.push(parent);
//   //     }

//   //     return result;
//   //   }

//   //   if (result) {
//   //     const storeRedux = store.getState().select;
//   //     const dataMenuKeys = {
//   //       keysMenu: result.key && result.key,
//   //       openTabs: getOpenTabsByDotKey(result.key)
//   //     };
//   //     // console.log('onClick', props, dataMenuKeys);
//   //     storeRedux && dispatch(updateActiveMenuHeader(dataMenuKeys));
//   //     return i18n.t(result?.title);
//   //   }
//   //   return null;
//   // }, [location]);

//   // const checkToken = async () => {
//   //   await AuthServiceApi.CheckExpireToken().then(res => {
//   //     if (res.data.data != true) {
//   //       console.log('về /login token hết hạn');
//   //       Cookies.remove('token');
//   //       localStorage.removeItem('role');
//   //       history('/login');
//   //     }
//   //   });
//   // };

//   // Thay đoạn checkToken và thêm refreshAccessToken
//   const refreshAccessToken = async (): Promise<string | null> => {
//     const refreshToken = Cookies.get('refreshToken');
//     if (!refreshToken) return null;

//     try {
//       const res = await AuthServiceApi.RefreshToken({
//         refreshToken,
//         os: 'WEB',
//         version: CONFIG_WEBSITE.version.split('V.').join('')
//       });

//       if (res.data.error === false) {
//         const { accessToken, refreshToken: newRefreshToken } = res.data.data;
//         Cookies.set('token', accessToken);
//         Cookies.set('refreshToken', newRefreshToken); // refreshToken cũ hết hiệu lực
//         window.sessionStorage.setItem('token', accessToken);
//         dispatch(updateToken(accessToken));
//         return accessToken;
//       }
//     } catch (err) {
//       console.error('RefreshToken failed', err);
//     }
//     return null;
//   };

//   const checkToken = async () => {
//     const res = await AuthServiceApi.CheckExpireToken();
//     if (res.data.data !== true) {
//       // accessToken hết hạn → thử refresh
//       const newToken = await refreshAccessToken();
//       if (!newToken) {
//         // refreshToken cũng hết → buộc logout
//         Cookies.remove('token');
//         Cookies.remove('refreshToken');
//         localStorage.removeItem('role');
//         history('/login');
//       }
//     }
//   };

//   useEffect(() => {
//     if ((token == undefined || !token) && Cookies.get('token')) {
//       dispatch(updateToken(Cookies.get('token')));
//     }
//     const tokenSave = token ? token : location.search.length != 0 && Cookies.get('token'); // dùng mở tab nhanh mới dùng lại token từ cookies, còn bth vẫn dùng token lưu store
//     const role = localStorage.getItem('role');
//     // console.log('token', !account, tokenSave);
//     // Có Token và chưa  thông tin của user này=>load và không load lại những lần sau
//     // nên có cái gì đó load chứ theo account khó xảy ra lắm
//     // console.log('roleTag 0', tokenSave, role, account);
//     if (tokenSave) {
//       // dispatch(getAllCompany());
//       // lấy role từ local vô nếu có từ local
//       // gọi kiểm tra tokenSave còn hạn hay không
//       checkToken();
//       console.log('roleTag 1', tokenSave, role);
//       if (role) {
//         const dehash = EnDeAES.aesDecrypt(EnDeAES.decodeBase64(role)!);
//         console.log('EnDeAES.aesDecrypt(role)', dehash);
//         dehash && dispatch(updateUserSlideFromLC(JSON.parse(dehash)));
//       } else {
//         dispatch(getUserCurrent()); // lấy lại thông tin user đang login và lưu vào local
//         // lấy role lại nè nếu token vẫn còn hạn
//       }
//       // console.log('loadedData', loadedData);
//       // get tiếp các cái khác cho lần đầu tiên
//       // if (companySelected && companyDataSelect) {
//       //   console.log('getting 0');
//       // }
//       // if (!loadedData.branchLoaded) {
//       //   dispatch(getAllBranch());
//       // }
//       // if (!loadedData.technicianZoneLoaded) {
//       //   dispatch(getAllTechnicianZone());
//       // }
//     } else if (!tokenSave) {
//       console.log('về /login k có token');
//       // false null undefined
//       history('/login');
//     }
//     console.log('render App when reload', window.Notification.permission);
//     if (window.Notification.permission + '' !== 'granted') {
//       // yc cấp quyền thông báo ngay lập tức
//       handlePermission();
//       message.warning(t('Notification.NeedAccessGetNotify'));
//     }
//     // tất cả những gì chạy ở đây chỉ 1 lần khi web đc load lên
//     !configStart && getJsonConfig();
//   }, []);

//   function handlePermission() {
//     navigator.permissions.query({ name: 'notifications' }).catch(err => {
//       console.log('err ');
//     });
//   }

//   const getJsonConfig = () => {
//     fetch(`${publicUrl}/data/configInit.json`, {
//       headers: {
//         'Content-Type': 'application/json',
//         Accept: 'application/json'
//       }
//     })
//       .then(function (response) {
//         return response.json();
//       })
//       .then(function (myJson) {
//         dispatch(updateConfigStart(myJson));
//       });
//   };

//   const renderLoadingPage = useMemo(() => {
//     return <LoadingPage />;
//   }, []);

//   return (
//     <ErrorBoundary>
//       <DocumentTitle title={documentTitle}>
//         <>
//           {renderLoadingPage}
//           {token && <Sider />}
//           <Suspense fallback={<Loading />}>
//             <Routes>
//               <Route path="/login" element={<Login />} />
//               {/* phần yêu cầu đăng nhập */}
//               {_routes}
//               <Route
//                 path="*"
//                 element={
//                   <RequireAuth hasSiderBar={true}>
//                     <Exception />
//                   </RequireAuth>
//                 }
//               />
//             </Routes>
//           </Suspense>
//         </>
//       </DocumentTitle>
//     </ErrorBoundary>
//   );
// }

// export default App;

/* eslint-disable react/react-in-jsx-scope */
import ErrorBoundary from '@components/ErrorBoundary';
import Exception from '@components/Exception';
import Loading from '@components/Loading';
import Sider from '@components/Sider';
import { routes, RouteProps } from '@lib/routes';
import Login from '@pages/User/Login/Login';
import { Layout, message } from 'antd';
import React, { Suspense, useEffect, useMemo, useRef } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import DocumentTitle from 'react-document-title';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import store, { RootState } from 'app/store';
import {
  LanguageSelectType,
  getUserCurrent,
  updateLanguage,
  updateToken,
  updateUserSlideFromLC
} from '@slice/user.slice';
import EnDeAES from 'helpers/EnDeAES';
import Cookies from 'js-cookie';
import { locale } from 'devextreme/localization';
import i18n from 'i18n/index';
import { ThunkDispatch } from '@reduxjs/toolkit';
import LoadingPage from '@components/common/LoadingPage';

import AuthServiceApi from 'apis/api/Auth';
import { useTranslation } from 'react-i18next';
import { getAllBranch, getAllTechnicianZone, updateActiveMenuHeader, updateConfigStart } from '@slice/select.slice';
import { publicUrl } from '@utils/env';
import { CONFIG_WEBSITE } from 'global/Global';
import { selectRoutesFilter } from '@lib/routeAccess';
function App() {
  const { t } = useTranslation();
  const history = useNavigate();
  const location = useLocation();
  const refRouteList = useRef<any>([]);
  const token = useSelector((state: RootState) => state.user.token);
  const configStart = useSelector((state: RootState) => state.select.configStart);
  // const routesFilter = useSelector((state: RootState) => state.user.routesFilter);

  const routesFilter = useSelector(selectRoutesFilter);
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  function RequireAuth({ children, hasSiderBar }: { children: any; hasSiderBar?: boolean }) {
    const collapsed = useSelector((state: RootState) => state.select.isCollapsedNav);
    if (!token) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    } else {
      if (hasSiderBar) {
        return (
          <>
            <Layout
              className={classNames(
                `${collapsed ? 'ml-[40px]' : 'ml-[200px]'} h-[calc(100vh-0rem)] overflow-y-auto bg-transparent`
              )}
            >
              <Layout.Content>{children}</Layout.Content>
            </Layout>
          </>
        );
      }
      return children;
    }
  }

  const renderRoute = (route: RouteProps | any) => {
    if (route.children) {
      if (routesFilter.includes(route.key)) {
        return null;
      }
      return route.children.map(renderRoute);
    }

    if (!route.Component || !route.url || routesFilter.includes(route.key)) {
      return null;
    }

    refRouteList.current = Array.from(new Set([...refRouteList.current, route]));
    return (
      <Route
        key={route.key}
        path={route.url}
        element={
          <RequireAuth hasSiderBar={true}>
            <route.Component />
          </RequireAuth>
        }
      />
    );
  };

  const _routes = routes
    .map(r => {
      if (r.children) {
        if (routesFilter.includes(r.key)) {
          return null;
        }
        return r.children.map(renderRoute);
      }
      return renderRoute(r);
    })
    .reduce((result: any[], route) => {
      if (!route) {
        return result;
      }
      if (Array.isArray(route)) {
        return [...result, ...route.filter(Boolean)];
      }

      result.push(route);
      return result;
    }, []);

  const documentTitle = React.useMemo(() => {
    if (i18n.language !== 'vn' && i18n.language !== 'en') {
      locale('vi');
      try {
        dispatch(updateLanguage(LanguageSelectType.VIETNAM));
        i18n.changeLanguage('vn');
      } catch (error) {
        console.log('error', error);
      }
    }

    function findRouteByPath(pathname: string, routes: any[]): any | null {
      for (const route of routes) {
        if (route.url === pathname) return route;
        if (route.children?.length) {
          const child = findRouteByPath(pathname, route.children);
          if (child) return child;
        }
      }
      return null;
    }

    function getOpenTabsByDotKey(key: string): string[] {
      if (!key) return [];
      const parts = key.split('.');
      const result: string[] = [];
      result.push(key);
      if (parts.length > 1) {
        const parent = parts.slice(0, parts.length - 1).join('.');
        result.push(parent);
      }
      return result;
    }

    const url = location;
    const result = findRouteByPath(url.pathname, routes);
    if (result?.key) {
      const dataMenuKeys = {
        keysMenu: result?.key,
        openTabs: getOpenTabsByDotKey(result?.key)
      };

      dispatch(updateActiveMenuHeader(dataMenuKeys));
      return i18n.t(result.title);
    } else {
      dispatch(updateActiveMenuHeader({ keysMenu: null, openTabs: [] }));
      return null;
    }
  }, [location]);

  const refreshAccessToken = async (): Promise<string | null> => {
    const refreshToken = Cookies.get('refreshToken');
    if (!refreshToken) return null;

    try {
      const res = await AuthServiceApi.RefreshToken({
        refreshToken,
        os: 'WEB',
        version: CONFIG_WEBSITE.version.split('V.').join('')
      });

      if (res.data.error === false) {
        const { accessToken, refreshToken: newRefreshToken } = res.data.data;
        Cookies.set('token', accessToken);
        Cookies.set('refreshToken', newRefreshToken);
        window.sessionStorage.setItem('token', accessToken);
        dispatch(updateToken(accessToken));
        return accessToken;
      }
    } catch (err) {
      console.error('RefreshToken failed', err);
    }
    return null;
  };

  const checkToken = async () => {
    const res = await AuthServiceApi.CheckExpireToken();
    if (res.data.data !== true) {
      const newToken = await refreshAccessToken();
      if (!newToken) {
        Cookies.remove('token');
        Cookies.remove('refreshToken');
        localStorage.removeItem('role');
        history('/login');
      }
    }
  };

  // useEffect(() => {
  //   if ((token == undefined || !token) && Cookies.get('token')) {
  //     dispatch(updateToken(Cookies.get('token')));
  //   }
  //   const tokenSave = token ? token : location.search.length != 0 && Cookies.get('token'); // dùng mở tab nhanh mới dùng lại token từ cookies, còn bth vẫn dùng token lưu store
  //   const role = localStorage.getItem('role');
  //   // console.log('token', !account, tokenSave);
  //   // Có Token và chưa  thông tin của user này=>load và không load lại những lần sau
  //   // nên có cái gì đó load chứ theo account khó xảy ra lắm
  //   // console.log('roleTag 0', tokenSave, role, account);
  //   if (tokenSave) {
  //     // dispatch(getAllCompany());
  //     // lấy role từ local vô nếu có từ local
  //     // gọi kiểm tra tokenSave còn hạn hay không
  //     checkToken();
  //     console.log('roleTag 1', tokenSave, role);
  //     if (role) {
  //       const dehash = EnDeAES.aesDecrypt(EnDeAES.decodeBase64(role)!);
  //       console.log('EnDeAES.aesDecrypt(role)', dehash);
  //       dehash && dispatch(updateUserSlideFromLC(JSON.parse(dehash)));
  //     } else {
  //       dispatch(getUserCurrent()); // lấy lại thông tin user đang login và lưu vào local
  //       // lấy role lại nè nếu token vẫn còn hạn
  //     }
  //     // console.log('loadedData', loadedData);
  //     // get tiếp các cái khác cho lần đầu tiên
  //     // if (companySelected && companyDataSelect) {
  //     //   console.log('getting 0');
  //     // }
  //     // if (!loadedData.branchLoaded) {
  //     //   dispatch(getAllBranch());
  //     // }
  //     // if (!loadedData.technicianZoneLoaded) {
  //     //   dispatch(getAllTechnicianZone());
  //     // }
  //   } else if (!tokenSave) {
  //     console.log('về /login k có token');
  //     // false null undefined
  //     history('/login');
  //   }
  //   console.log('render App when reload', window.Notification.permission);
  //   if (window.Notification.permission + '' !== 'granted') {
  //     // yc cấp quyền thông báo ngay lập tức
  //     handlePermission();
  //     message.warning(t('Notification.NeedAccessGetNotify'));
  //   }
  //   // tất cả những gì chạy ở đây chỉ 1 lần khi web đc load lên
  //   !configStart && getJsonConfig();
  // }, []);

  useEffect(() => {
    const cookieToken = Cookies.get('token');
    if (!token && cookieToken) {
      dispatch(updateToken(cookieToken));
    }
    const tokenSave = token ? token : location.search.length != 0 && Cookies.get('token');
    const role = localStorage.getItem('role');

    if (tokenSave) {
      checkToken();

      if (role) {
        const dehash = EnDeAES.aesDecrypt(EnDeAES.decodeBase64(role)!);
        dehash && dispatch(updateUserSlideFromLC(JSON.parse(dehash)));
      } else {
        dispatch(getUserCurrent());
      }

      // === BỔ SUNG GỌI LẠI CÁC API DANH MỤC Ở ĐÂY ===
      // Dispatch các action lấy danh sách chi nhánh và khu vực kỹ thuật để không bị mất khi F5
      dispatch(getAllBranch()); // Thay thế bằng action thực tế trong slice/thunk của bạn (ví dụ: select.slice)
      dispatch(getAllTechnicianZone()); // Tương tự cho khu vực kỹ thuật
    } else if (!tokenSave) {
      console.log('về /login k có token');
      history('/login');
    }

    if (window.Notification.permission + '' !== 'granted') {
      handlePermission();
      message.warning(t('Notification.NeedAccessGetNotify'));
    }

    !configStart && getJsonConfig();
  }, []); // Chỉ chạy mount 1 lần

  function handlePermission() {
    navigator.permissions.query({ name: 'notifications' }).catch(err => {
      console.log('err ', err);
    });
  }

  const getJsonConfig = () => {
    fetch(`${publicUrl}/data/configInit.json`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (myJson) {
        dispatch(updateConfigStart(myJson));
      });
  };

  const renderLoadingPage = useMemo(() => {
    return <LoadingPage />;
  }, []);

  return (
    <ErrorBoundary>
      <DocumentTitle title={documentTitle}>
        <>
          {renderLoadingPage}
          {token && <Sider />}
          <Suspense fallback={<Loading />}>
            <Routes>
              {/* FIX LỖI 2: Chặn tuyệt đối user quay lại trang login khi đã có token bằng cách redirect ra "/" */}
              <Route path="/login" element={token ? <Navigate to="/" replace /> : <Login />} />

              {/* phần yêu cầu đăng nhập */}
              {_routes}
              <Route
                path="*"
                element={
                  <RequireAuth hasSiderBar={true}>
                    <Exception />
                  </RequireAuth>
                }
              />
            </Routes>
          </Suspense>
        </>
      </DocumentTitle>
    </ErrorBoundary>
  );
}

export default App;
